import React, { useState } from 'react'
import { Search } from '../Search'
import { ClientSearch } from './ClientSearch'
import { UserSearch } from './UserSearch'
import { RecentSearches } from './RecentSearches'
import { CheckUserRole } from '../CheckUserRole'
import { Typography } from '..'
import { GET_TEAMS } from '../../../grapghQl/queries/teams'
import { useMutation, useQuery } from '@apollo/client'
import { GET_GLOBAL_SEARCH } from '../../../grapghQl/queries/clients'
import { SAVE_GLOBAL_SEARCH } from '../../../grapghQl/queries/dashboard'
import { useToasts } from '../../Toast'
import { useClickOutside } from '../../useOutsideClick'

export const HeaderSearch = () => {
    const searchRef = React.createRef();
    const { setToastMessage } = useToasts();
    const [searchText, setSearchText] = useState("");
    const [openSuggestions, setOpenSuggestions] = useState(false);
    const [openrecents, setOpenRecents] = useState(false);
    const { isAssociate } = CheckUserRole();
    const [saveSearchHistoryAPI] = useMutation(SAVE_GLOBAL_SEARCH);

    const { data: { teamsList: { teamsData = [] } = {} } = {}, loading: teamsLoader } = useQuery(GET_TEAMS, {
        fetchPolicy: 'no-cache',
        skip: searchText === "",
        variables: {
            startRow: 0, endRow: 8, sorting: [], filterModel: {
                name: { filterType: "text", type: "contains", filter: searchText },
                status: { filterType: "text", type: "contains", filter: "Active" }
            }
        }
    })

    const { data: { supportClientList: clientsData = [] } = {}, loading: clientLoader } = useQuery(GET_GLOBAL_SEARCH, {
        fetchPolicy: 'no-cache',
        skip: searchText === "",
        variables: {
            searchName: searchText
        }
    })

    const onChangeSearch = (value) => {
        setSearchText(value);
        if (value?.length) { setOpenRecents(false); setOpenSuggestions(true); }
        else { setOpenRecents(true) }
    };

    const closeFilterMenu = () => {
        setOpenSuggestions(false); setOpenRecents(false); setSearchText("");
    }

    const onFocus = (state) => { setOpenSuggestions(false); setOpenRecents(state) }

    const saveSearchHistory = async (payload) => {
        try {
            const { data } = await saveSearchHistoryAPI({ variables: payload })
            return data ? true : false
        } catch (error) {
            setToastMessage({ message: error?.message, variant: "error" });
            return false
        }
    }

    const clickOutSideMenu = () => closeFilterMenu();

    useClickOutside(searchRef, clickOutSideMenu)

    return (
        <div ref={searchRef} className='mx-3 relative w-full' >
            <Search searchText={searchText} onFocus={onFocus} onChangeSearch={onChangeSearch} mainClassName="w-full" className="w-full"
                placeholderText={isAssociate ? "Search Client" : "Search Client or User"} parentClassName="w-full min-w-[300px] lg:min-w-[35rem]" />
            {openrecents ? <div className='absolute border z-[10] border-secondary-200 top-[2.7rem] rounded-md bg-white p-3 w-full'>
                <RecentSearches closeFilterMenu={closeFilterMenu} /> </div> :
                openSuggestions && <div className='absolute max-h-[60vh] border overflow-y-auto z-[10] border-secondary-200 top-[2.7rem] rounded-md bg-white p-3 w-full'>
                    {(clientsData?.length !== 0 || teamsData?.length !== 0) || (teamsLoader || clientLoader) ? <>
                        <ClientSearch saveSearchHistory={saveSearchHistory}
                            closeFilterMenu={closeFilterMenu}
                            loading={teamsLoader} setSearchText={setSearchText}
                            clientsData={clientsData}
                        />
                        <div className='w-full border-t border-b-0 border-l-0 border-r-0 border-secondary-200'></div>
                        {!isAssociate && <UserSearch saveSearchHistory={saveSearchHistory}
                            closeFilterMenu={closeFilterMenu}
                            loading={clientLoader}
                            teamsData={teamsData} setSearchText={setSearchText}
                        />}
                    </> :
                        <div className='flex justify-center  h-48 items-center w-full'>
                            <Typography variant="sm" text={isAssociate ? "No Clients found" : "No Clients or User found"} className="text-secondary-400" />
                        </div>}
                </div>}
        </div>

    )
}

